import { post, put } from '../request'

export const createImplementationOffer = (params) => post('api/implementation-offers', params)
export const updateImplementationOffer = (offerId, data) => put(`api/implementation-offers/${offerId}`, data)
